namespace $ {
	$.$hyoo_crus_mine = $hyoo_crus_mine_idb
}
